import { Component, Input, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'agpr-distribution-view-in-browser',
    templateUrl: './distribution-view-in-browser.component.html',
    styleUrls: ['./distribution-view-in-browser.component.scss'],
    standalone: false
})
export class DistributionViewInBrowserComponent{
    @Input() text: string;
    @Input() show: boolean;
}
